import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/ROS4kbS2DfVdBdDZzXBa/locations/${locationId}`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="290px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/ROS4kbS2DfVdBdDZzXBa/locations/${locationId}`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="270px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
